import styled from "@emotion/styled";
import { Typography } from "antd";
import { FontWeights, StyledTextProps } from "./typography.types";
import { getTextColorFromToken } from "./utils";

const getFontSize = ({ level, token }: StyledTextProps) => {
    switch (level) {
        case 1:
            return token.fontSizeLG;
        case 3:
            return token.fontSizeSM;
        default:
            return token.fontSize;
    }
};

const getFontColor = ({ type, token, disabled }: StyledTextProps) => {
    return getTextColorFromToken(type, token, disabled);
};

export const StyledText = styled(Typography.Text)<StyledTextProps>`
    font-size: ${({ level, token }) => getFontSize({ level, token })}px;
    line-height: 155%;
    font-weight: ${FontWeights.regular};
    && {
        color: ${({ type, token, disabled }) =>
            getFontColor({ type, token, disabled })};
    }
    mark {
        background-color: ${({ token }) => token.color.border.borderCaution};
    }
`;
